import React from 'react';
import { getTodayTimeStr, getTodayTime, isAllowedDate } from '../util/';
export default function TodayButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      value = _ref.value,
      timePicker = _ref.timePicker,
      disabled = _ref.disabled,
      disabledDate = _ref.disabledDate,
      onToday = _ref.onToday,
      text = _ref.text;
  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
  var disabledToday = disabledDate && !isAllowedDate(getTodayTime(value), disabledDate);
  var isDisabled = disabledToday || disabled;
  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
  return React.createElement('a', {
    className: prefixCls + '-today-btn ' + disabledTodayClass,
    role: 'button',
    onClick: isDisabled ? null : onToday,
    title: getTodayTimeStr(value)
  }, localeNow);
}